<li class="onhover-dropdown push-device-bell">
  <div
    class="push-device-bell__trigger mx-2 position-relative"
    [class.push-device-bell__trigger--enabled]="enabled"
    [class.push-device-bell__trigger--disabled]="!enabled && !loading"
    [class.push-device-bell__trigger--loading]="loading"
    (click)="toggleDropdown()"
    [attr.aria-label]="'notifications.deviceBellTitle' | translate"
    role="button"
    tabindex="0"
  >
    <ng-container *ngIf="enabled; else bellOff">
      <app-feather-icons icon="bell"></app-feather-icons>
    </ng-container>
    <ng-template #bellOff>
      <app-feather-icons icon="bell-off"></app-feather-icons>
    </ng-template>

    <span class="push-device-bell__dot push-device-bell__dot--on" *ngIf="enabled"></span>
    <span class="push-device-bell__badge" *ngIf="unreadCount > 0">
      {{ unreadCount > 99 ? '99+' : unreadCount }}
    </span>
  </div>

  <div class="onhover-show-div push-device-bell__dropdown" [class.active]="open">
    <app-push-device-settings [compact]="true"></app-push-device-settings>

    <div class="pdb-log">
      <div class="pdb-log__header">
        <div class="pdb-log__header-left">
          <span class="pdb-log__title">{{ 'notifications.logTitle' | translate }}</span>
          <span class="pdb-log__unread-pill" *ngIf="unreadCount > 0">
            {{ unreadCount }}
          </span>
        </div>
        <button
          class="pdb-log__mark-all"
          *ngIf="unreadCount > 0"
          (click)="markAllRead()"
          type="button"
        >
          <app-feather-icons icon="check"></app-feather-icons>
          {{ 'notifications.logMarkAllRead' | translate }}
        </button>
      </div>

      <ng-container *ngIf="log.loading && log.items.length === 0">
        <div class="pdb-log__scroll">
          <div class="pdb-log__skeleton" *ngFor="let i of [1,2,3]">
            <div class="pdb-log__skeleton-icon"></div>
            <div class="pdb-log__skeleton-lines">
              <div class="pdb-log__skeleton-line pdb-log__skeleton-line--title"></div>
              <div class="pdb-log__skeleton-line pdb-log__skeleton-line--body"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="pdb-log__empty pdb-log__empty--error" *ngIf="!log.loading && log.error">
        <app-feather-icons icon="alert-circle"></app-feather-icons>
        <span>{{ 'notifications.logError' | translate }}</span>
        <button class="pdb-log__retry-btn" type="button" (click)="loadMore()">
          {{ 'notifications.logRetry' | translate }}
        </button>
      </div>

      <div class="pdb-log__empty" *ngIf="!log.loading && !log.error && log.items.length === 0">
        <div class="pdb-log__empty-icon">
          <app-feather-icons icon="inbox"></app-feather-icons>
        </div>
        <span>{{ 'notifications.logEmpty' | translate }}</span>
      </div>

      <div class="pdb-log__scroll" *ngIf="log.items.length > 0">
        <div
          class="pdb-log__item"
          [class.pdb-log__item--unread]="!item.is_read"
          *ngFor="let item of log.items; trackBy: trackById"
          (click)="onItemClick($event, item)"
          role="button"
          tabindex="0"
        >
          <div
            class="pdb-log__item-icon"
            [class.pdb-log__item-icon--unread]="!item.is_read"
          >
            <app-feather-icons [icon]="getTypeIcon(item.notification_type)"></app-feather-icons>
          </div>

          <div class="pdb-log__item-body">
            <div class="pdb-log__item-head">
              <p class="pdb-log__item-title" dir="auto">{{ item.title }}</p>
              <span class="pdb-log__item-dot" *ngIf="!item.is_read"></span>
            </div>
            <p class="pdb-log__item-msg" dir="auto">{{ item.message }}</p>
            <div class="pdb-log__item-footer">
              <div class="pdb-log__item-tags" *ngIf="item.notification_type || item.notification_source">
                <span class="pdb-log__item-tag pdb-log__item-tag--type" *ngIf="item.notification_type">
                  {{ typeLabel(item.notification_type) }}
                </span>
                <span class="pdb-log__item-tag pdb-log__item-tag--source" *ngIf="item.notification_source">
                  {{ sourceLabel(item.notification_source) }}
                </span>
              </div>
              <span class="pdb-log__item-time">{{ item.created_at | date: 'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>

          <div class="pdb-log__item-chevron">
            <app-feather-icons icon="chevron-left"></app-feather-icons>
          </div>
        </div>
      </div>

      <div class="pdb-log__actions" *ngIf="!(log.loading && log.items.length === 0)">
        <button type="button" class="pdb-log__action pdb-log__action--primary" (click)="openCenter($event)">
          <app-feather-icons icon="inbox"></app-feather-icons>
          {{ 'notifications.center.viewAll' | translate }}
        </button>
        <button type="button" class="pdb-log__action pdb-log__action--secondary" (click)="openSettings($event)">
          <app-feather-icons icon="settings"></app-feather-icons>
          {{ 'notifications.center.openSettings' | translate }}
        </button>
      </div>

      <div class="pdb-log__footer" *ngIf="log.hasMore">
        <button
          class="pdb-log__load-more"
          type="button"
          [disabled]="log.loading"
          (click)="loadMore()"
        >
          <ng-container *ngIf="log.loading; else loadMoreLabel">
            <span class="pdb-log__spinner"></span>
          </ng-container>
          <ng-template #loadMoreLabel>
            {{ 'notifications.logLoadMore' | translate }}
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</li>
